import { useEffect } from "react";
import SessionCacheService from "../../utilities/sessionCacheService";
import { WbmMainHeaderApi } from "@wbmason/main-header-api";

export interface INotificationsProps {
  deliveryNotifications: any;
  ordersAwaitingApproval: any;
  animateBellCallback: () => void;
}

const NotificationsAlertTimeKey = "NotificationsAlertTime";
const NotificationsAlertShakeCountKey = "NotificationsAlertTimeShakeCount";
const NotificationsBellCountKey = "NotificationsBellCount";

export function NotificationsBell(props: INotificationsProps) {
  useEffect(() => {
    if (
      props.deliveryNotifications &&
      props.ordersAwaitingApproval &&
      props.deliveryNotifications.deliveryCount !== undefined &&
      props.ordersAwaitingApproval.notificationCount !== undefined &&
      (props.deliveryNotifications.deliveryCount > 0 ||
        props.ordersAwaitingApproval.notificationCount > 0)
    ) {
      var currentCount =
        props.deliveryNotifications.deliveryCount +
        props.ordersAwaitingApproval.notificationCount;

      var oldCount = parseInt(
        SessionCacheService.getValue(NotificationsBellCountKey),
      );

      if (oldCount < currentCount) {
        SessionCacheService.set(NotificationsAlertTimeKey, Date.now());
        SessionCacheService.set(NotificationsAlertShakeCountKey, 1);
        props.animateBellCallback();
      } else {
        var notificationsAlertTime = SessionCacheService.getValue(
          NotificationsAlertTimeKey,
        );

        var notificationsAlertShakeCountKey = parseInt(
          SessionCacheService.getValue(NotificationsAlertShakeCountKey)
            ? SessionCacheService.getValue(NotificationsAlertShakeCountKey)
            : 0,
        );

        if (
          (!notificationsAlertTime ||
            Date.now() - notificationsAlertTime > 480000) &&
          notificationsAlertShakeCountKey < 2
        ) {
          SessionCacheService.set(NotificationsAlertTimeKey, Date.now());
          SessionCacheService.set(
            NotificationsAlertShakeCountKey,
            notificationsAlertShakeCountKey + 1,
          );

          props.animateBellCallback();
        }
      }
      SessionCacheService.set(NotificationsBellCountKey, currentCount);
      WbmMainHeaderApi.updateNotficationCount(currentCount);
    }
  }, [props]);

  return null;
}
